import { AgendaElements } from "./agenda-elements.module";
import { AgendaEvents } from "./agenda-events.module";
import { AgendaFilter } from "./agenda-filter.module";
import { AgendaRenderer } from "./agenda-renderer.module";
import { AgendaState } from "./agenda-state.module";

export class AgendaModule {
  initialize() {
    this.agendas = document.querySelectorAll(".agenda-overview");
    this.agendas.forEach((agenda) => new Agenda(agenda));
  }
}

class Agenda {
  constructor(agenda) {
    this.agenda = agenda;
    this.elements = new AgendaElements(agenda);

    this.state = new AgendaState();
    this.filter = new AgendaFilter(this.elements.items);
    this.events = new AgendaEvents(this.state, this.elements);
    this.renderer = new AgendaRenderer(this.elements);

    this.initialize();
  }

  initialize() {
    this.state.onStateChange((state) => this.render(state));
    this.events.attachEvents();
    
    this.state.set("headerHeight", document.querySelector("header").offsetHeight);
  }

  render(state) {
    const activeItems = this.filter.getActiveItems(state.searchQuery, state.category, state.location);
    const inactiveItems = this.filter.getInactiveItems(activeItems);

    this.renderer.updateItems(activeItems, inactiveItems);
    this.renderer.updateMonths();
    this.renderer.updateNoItemsMessage(activeItems.length > 0);
    this.renderer.updateFilterPosition(state.headerHeight);
    this.renderer.updateRightMargin();
  }
}